<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Home from './components/Home.vue';
import 'bootstrap/dist/css/bootstrap.css';

export default {
  name: 'app',
  components: {
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.btn{
  border-radius:0;
  background-color:#367bc9;
  border:0;
}
.btn:hover{
  background-color:#3f6b9c;
}

.image-modal-header{
  border-bottom: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  padding-bottom: 0;
}
.image-modal-body{
  padding-top: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>
